module.exports = __webpack_public_path__ + "static/mobile-traffic-18fe85e53bcef9c918a3bfe82ed11859.jpg";